export var WidgetSize;
(function (WidgetSize) {
    WidgetSize[WidgetSize["Button"] = 0] = "Button";
    WidgetSize[WidgetSize["Frame"] = 1] = "Frame";
    WidgetSize[WidgetSize["FullScreen"] = 2] = "FullScreen";
})(WidgetSize || (WidgetSize = {}));
export var WidgetPlaceholderType;
(function (WidgetPlaceholderType) {
    WidgetPlaceholderType[WidgetPlaceholderType["Docked"] = 0] = "Docked";
    WidgetPlaceholderType[WidgetPlaceholderType["Tiles"] = 1] = "Tiles";
    WidgetPlaceholderType[WidgetPlaceholderType["Floating"] = 2] = "Floating";
})(WidgetPlaceholderType || (WidgetPlaceholderType = {}));
